import { atom } from 'recoil'
import { ISelfInfoState } from '@/pages/User/user.types.ts'

const userAtom = atom<ISelfInfoState>({
  key: 'self/user',
  default: {
    isNotificationsViewed: false,
  } as ISelfInfoState,
})

export default userAtom
